import {
	SnippetsOutlined,
	QuestionCircleOutlined,
	GlobalOutlined,
	LoadingOutlined
} from '@ant-design/icons';
import { ReactComponent as Eye } from 'Icons/eye.svg';
import { ReactComponent as FileText } from 'Icons/file-text.svg';
import { ReactComponent as ModelFund } from 'Icons/model-fund.svg';
import { ReactComponent as Settings } from 'Icons/settings.svg';
import { ReactComponent as Stack } from 'Icons/stack.svg';
import { ReactComponent as ExclamationCircle } from 'Icons/exclamation-circle.svg';
import { ReactComponent as Close } from 'Icons/close.svg';
import { ReactComponent as ChevronDown } from 'Icons/chevron-down.svg';
import { ReactComponent as Help } from 'Icons/help.svg';
import { ReactComponent as Bell } from 'Icons/bell.svg';
import { ReactComponent as ArrowLeft } from 'Icons/arrow-left.svg';
import { ReactComponent as FlagUs } from 'Icons/flag-usa.svg';
import { ReactComponent as FlagFr } from 'Icons/flag-fr.svg';
import { ReactComponent as FlagEs } from 'Icons/flag-es.svg';
import { ReactComponent as Plus } from 'Icons/plus.svg';
import { ReactComponent as PlusEllipsis } from 'Icons/plus-ellipsis.svg';
import { ReactComponent as MinusCircle } from 'Icons/minus-circle.svg';
import { ReactComponent as More } from 'Icons/more.svg';
import { ReactComponent as Search } from 'Icons/search.svg';
import { ReactComponent as Filter } from 'Icons/filter.svg';
import { ReactComponent as Download } from 'Icons/download.svg';
import { ReactComponent as Move } from 'Icons/move.svg';
import { ReactComponent as Check } from 'Icons/check.svg';
import { ReactComponent as CheckCircle } from 'Icons/check-circle.svg';
import { ReactComponent as Delete } from 'Icons/delete.svg';
import { ReactComponent as Edit } from 'Icons/edit.svg';
import { ReactComponent as Password } from 'Icons/password.svg';
import { ReactComponent as Users } from 'Icons/users.svg';
import { ReactComponent as Restore } from 'Icons/restore.svg';
import { ReactComponent as Import } from 'Icons/import.svg';
import { ReactComponent as Copy } from 'Icons/copy.svg';
import { ReactComponent as Unlock } from 'Icons/unlock.svg';
import { ReactComponent as Lock } from 'Icons/lock.svg';
import { ReactComponent as InfoOutlined } from 'Icons/info-outlined.svg';
import { ReactComponent as Hierarchy } from 'Icons/hierarchy.svg';
import { ReactComponent as Information } from 'Icons/information.svg';
import { ReactComponent as Property } from 'Icons/property.svg';
import { ReactComponent as Like } from 'Icons/like.svg';
import { ReactComponent as Dislike } from 'Icons/dislike.svg';
import { ReactComponent as Neutral } from 'Icons/neutral.svg';
import { ReactComponent as TrendUp } from 'Icons/trend-up.svg';
import { ReactComponent as TrendDown } from 'Icons/trend-down.svg';
import { ReactComponent as Envelope } from 'Icons/envelope.svg';
import { ReactComponent as Click } from 'Icons/click.svg';
import { ReactComponent as NewWindow } from 'Icons/new-window.svg';
import { ReactComponent as Reward } from 'Icons/reward.svg';
import { ReactComponent as Sandglass } from 'Icons/sandglass.svg';
import { ReactComponent as Play } from 'Icons/play.svg';
import { ReactComponent as DownloadCircle } from 'Icons/download-circle.svg';
import { ReactComponent as Report } from 'Icons/report.svg';
import { ReactComponent as Calendar } from 'Icons/calendar.svg';
import { ReactComponent as Profile } from 'Icons/profile.svg';
import { ReactComponent as Success } from 'Icons/success.svg';
import { ReactComponent as Discount } from 'Icons/discount.svg';
import { ReactComponent as Time } from 'Icons/time.svg';
import { ReactComponent as EyeCrossed } from 'Icons/eye-crossed.svg';
import { ReactComponent as EyeOpened } from 'Icons/eye-opened.svg';
import { ReactComponent as NewEyeCrossed } from 'Icons/new-eye-crossed.svg';
import { ReactComponent as NewEyeOpened } from 'Icons/new-eye-oppened.svg';
import { ReactComponent as MappingSetting } from 'Icons/mapping-settings.svg';
import { ReactComponent as NotStarted } from 'Icons/not-started.svg';
import { ReactComponent as InComplete } from 'Icons/incomplete.svg';
import { ReactComponent as NeedsReview } from 'Icons/needs-review.svg';
import { ReactComponent as CreateMapping } from 'Icons/create-mapping.svg';
import { ReactComponent as UnMapping } from 'Icons/unmapping.svg';
import { ReactComponent as Tenant } from 'Icons/tenant.svg';
import { ReactComponent as Excel } from 'Icons/excel.svg';
import { ReactComponent as UploadFile } from 'Icons/upload-file.svg';
import { ReactComponent as UploadPlaceholder } from 'Icons/upload-placeholder.svg';
import { ReactComponent as AddNewMapping } from 'Icons/add-new-mapping.svg';
import { ReactComponent as CreateNewMapping } from 'Icons/create-new-mapping.svg';
import { ReactComponent as ModalConfirmation } from 'Icons/modal-confirmation.svg';
import { ReactComponent as MappingEdit } from 'Icons/mapping-edit.svg';
import { ReactComponent as MappingIgnore } from 'Icons/mapping-ignore.svg';
import { ReactComponent as MappingTrash } from 'Icons/mapping-trash.svg';
import { ReactComponent as Matches } from 'Icons/matches.svg';

import { ReactComponent as AlertSuccess } from 'Icons/alert-success.svg';
import { ReactComponent as MappingSummary } from 'Icons/mapping-summary.svg';
import { ReactComponent as TenantFile } from 'Icons/tenant-file.svg';
import { ReactComponent as Confirmation } from 'Icons/confirmation.svg';
import { ReactComponent as RemovedMapping } from 'Icons/removed-mapping.svg';
import { ReactComponent as NewMapping } from 'Icons/new-mapping.svg';
import { ReactComponent as NoChanges } from 'Icons/no-changes.svg';
import { ReactComponent as SelectSuffix } from 'Icons/select-suffix.svg';
import { ReactComponent as TenantSuffix } from 'Icons/tenant-suffix.svg';
import { ReactComponent as MappingComplete } from 'Icons/mapping-complete.svg';
import { ReactComponent as ChevronLeft } from 'Icons/chevron-left.svg';
import { ReactComponent as Completed } from 'Icons/completed.svg';
import { ReactComponent as ChevronUp } from 'Icons/chevron-up.svg';
import { ReactComponent as ChevronUpDown } from 'Icons/chevrons-up-down.svg';
import { ReactComponent as Compliant } from 'Icons/compliant.svg';
import { ReactComponent as NonCompliant } from 'Icons/non-compliant.svg';
import { ReactComponent as SAQTooltip } from 'Icons/saq-tooltip.svg';
import { ReactComponent as AntSelectSuffix } from 'Icons/ant-select-suffix.svg';
import { ReactComponent as SAQExternalLink } from 'Icons/saq-external-link.svg';
import { ReactComponent as SAQSearch } from 'Icons/saq-search.svg';
import { ReactComponent as NonCompliantCard } from 'Icons/non-compliant-card.svg';
import { ReactComponent as SAQNumber } from 'Icons/saq-number.svg';
import { ReactComponent as SAQPercent } from 'Icons/saq-percent.svg';
import { ReactComponent as TrendingArrow } from 'Icons/trending-arrow.svg';
import { ReactComponent as UnmapExclamatory } from 'Icons/unmap-exclamatory.svg';
import { ReactComponent as ConnectionArrow } from 'Icons/connection-arrow.svg';
import { ReactComponent as RestoreReverse } from 'Icons/restore-reverse.svg';
import { ReactComponent as Remove } from 'Icons/remove.svg';
import { ReactComponent as CampaignAction } from 'Icons/compaign-action.svg';
import { ReactComponent as NoCampaign } from 'Icons/no-campaign.svg';
import { ReactComponent as CampaignAdd } from 'Icons/campaign-add.svg';
import { ReactComponent as CampaignAddDisabled } from 'Icons/campaign-add-disabled.svg';
import { ReactComponent as CampaignDropdown } from 'Icons/campaign-dropdown.svg';
import { ReactComponent as CampaignInfo } from 'Icons/campaign-info.svg';
import { ReactComponent as CampaignModalClose } from 'Icons/campaign-modal-close.svg';
import { ReactComponent as CampaignCalendar } from 'Icons/campaign-calendar.svg';
import { ReactComponent as PhishingManagerWarningToastClose } from 'Icons/phishing-manager-warning-toast-close.svg';
import { ReactComponent as PhishingManagerWarningToastPrefix } from 'Icons/phishing-manager-warning-toast-prefix.svg';
import { ReactComponent as CampaignSetupDropdown } from 'Icons/campaign-setup-dropdown.svg';
import { ReactComponent as CampaignSetupSearch } from 'Icons/campaign-setup-search.svg';
import { ReactComponent as CampaignSetupClose } from 'Icons/campaign-setup-close.svg';
import { ReactComponent as PreviousPagination } from 'Icons/previous-pagination.svg';
import { ReactComponent as NextPagination } from 'Icons/next-pagination.svg';
import { ReactComponent as CampaignPaginationNext } from 'Icons/campaign-pagination-next.svg';
import { ReactComponent as CampaignPaginationNextBlur } from 'Icons/campaign-pagination-next-blur.svg';
import { ReactComponent as CampaignStepClose } from 'Icons/campaign-step-close.svg';
import { ReactComponent as NewLogo } from 'Icons/newLogo.svg';
import { ReactComponent as VenzaLanding } from 'Icons/venzaLanding.svg';
import { ReactComponent as table } from 'Icons/table.svg';
import { ReactComponent as gear } from 'Icons/gear.svg';
import { ReactComponent as multiusers } from 'Icons/multi-users.svg';
import { ReactComponent as RecipientIndividual } from 'Icons/recipient-individual.svg';
import { ReactComponent as RecipientBuilding } from 'Icons/recipient-building.svg';
import { ReactComponent as RecipientRole } from 'Icons/recipient-role.svg';
import { ReactComponent as RecipientGroup } from 'Icons/recipient-group.svg';
import { ReactComponent as StepInProgress } from 'Icons/step-in-progress.svg';
import { ReactComponent as CampaignError } from 'Icons/campaign-error.svg';
import { ReactComponent as SummaryBack } from 'Icons/summary-back.svg';

import { ReactComponent as Feedback } from 'Icons/feedback.svg';
import { ReactComponent as CalendarReport } from 'Icons/calendar-report.svg';
import { ReactComponent as UsersReport } from 'Icons/users-report.svg';
import { ReactComponent as Properties } from 'Icons/properties.svg';
import { ReactComponent as Shield } from 'Icons/shield.svg';
import { ReactComponent as EmailSent } from 'Icons/email-sent.svg';
import { ReactComponent as EmailOpen } from 'Icons/email-open.svg';
import { ReactComponent as UserClick } from 'Icons/user-click.svg';
import { ReactComponent as SubmittedData } from 'Icons/submitted-data.svg';
import { ReactComponent as SubmittedDataFair } from 'Icons/submitted-data-fair.svg';
import { ReactComponent as SubmittedDataPoor } from 'Icons/submitted-data-poor.svg';
import { ReactComponent as Human } from 'Icons/human.svg';
import { ReactComponent as SystemInteraction } from 'Icons/system-interaction.svg';
import { ReactComponent as InfoTooltip } from 'Icons/info-tooltip.svg';
import { ReactComponent as ManageIcon } from 'LearningManager/icons/manage-icon.svg';
import { ReactComponent as ChatIcon } from 'LearningManager/icons/chat-icon.svg';
import { ReactComponent as QuickSetupIcon } from 'LearningManager/icons/quick-setup-icon.svg';
import { ReactComponent as CustomSetupIcon } from 'LearningManager/icons/custom-setup-icon.svg';
import { ReactComponent as ReccStarsIcon } from 'LearningManager/icons/recc-stars-icon.svg';
import { ReactComponent as ClockIcon } from 'LearningManager/icons/clock-icon.svg';
import { ReactComponent as PathIcon } from 'LearningManager/icons/path-icon.svg';
import { ReactComponent as DurationIcon } from 'LearningManager/icons/duration-icon.svg';
import { ReactComponent as StartIcon } from 'LearningManager/icons/start-icon.svg';
import { ReactComponent as DueDateIcon } from 'LearningManager/icons/due-date-icon.svg';
import { ReactComponent as AssignTypeIcon } from 'LearningManager/icons/assign-type-icon.svg';
import { ReactComponent as DatePickerIcon } from 'LearningManager/icons/date-picker-icon.svg';
import { ReactComponent as CreatedIcon } from 'LearningManager/icons/created-icon.svg';
import { ReactComponent as OrgIcon } from 'LearningManager/icons/org-icon.svg';
import { ReactComponent as PropIcon } from 'LearningManager/icons/prop-icon.svg';
import { ReactComponent as RoleIcon } from 'LearningManager/icons/role-icon.svg';
import { ReactComponent as IndividualIcon } from 'LearningManager/icons/individual-icon.svg';
import { ReactComponent as GroupIcon } from 'LearningManager/icons/group-icon.svg';
import { ReactComponent as OrgOptIcon } from 'LearningManager/icons/org-opt-icon.svg';
import { ReactComponent as PropOptIcon } from 'LearningManager/icons/prop-opt-icon.svg';
import { ReactComponent as RoleOptIcon } from 'LearningManager/icons/role-opt-icon.svg';
import { ReactComponent as IndividualOptIcon } from 'LearningManager/icons/individual-opt-icon.svg';
import { ReactComponent as GroupOptIcon } from 'LearningManager/icons/group-opt-icon.svg';
import { ReactComponent as OrgOptFilled } from 'LearningManager/icons/org-opt-filled.svg';
import { ReactComponent as PropOptFilled } from 'LearningManager/icons/prop-opt-filled.svg';
import { ReactComponent as RoleOptFilled } from 'LearningManager/icons/role-opt-filled.svg';
import { ReactComponent as IndiOptFilled } from 'LearningManager/icons/indi-opt-filled.svg';
import { ReactComponent as GroupOptFilled } from 'LearningManager/icons/group-opt-filled.svg';
import { ReactComponent as WarningFilledIcon } from 'LearningManager/icons/warning-filled-icon.svg';
import { ReactComponent as NoAssignments } from 'LearningManager/icons/no-assignments.svg';
import { ReactComponent as FilterNoAssignments } from 'LearningManager/icons/filter-no-assignments.svg';
import { ReactComponent as LearningPathOutline } from 'LearningManager/icons/learning-path-outline.svg';
import { ReactComponent as IndiCourses } from 'LearningManager/icons/indi-courses.svg';
import { ReactComponent as IndiCoursesOutline } from 'LearningManager/icons/indi-courses-outline.svg';
import { ReactComponent as InfoFilled } from 'LearningManager/icons/info-filled.svg';
import { ReactComponent as GrayCourseIcon } from 'LearningManager/icons/gray-course.svg';
import { ReactComponent as OptionalCourseIcon } from 'LearningManager/icons/optional-course.svg';
import { ReactComponent as TickBoxIcon } from 'LearningManager/icons/tick-box.svg';
import { ReactComponent as WarningCubeIcon } from 'LearningManager/icons/warning-cube.svg';

import { ReactComponent as PhishingMenuIcon } from 'Icons/phishing-shield-icon.svg';
import { ReactComponent as SaqMenuIcon } from 'Icons/saq-icon.svg';
import { ReactComponent as LibraryMenuIcon } from 'Icons/library-icon.svg';
import { ReactComponent as ScanningMenuIcon } from 'Icons/scanning-icon.svg';
import { ReactComponent as SavedMenuIcon } from 'Icons/saved-icon.svg';
import { ReactComponent as AuditLogMenuIcon } from 'Icons/audit-log-icon.svg';
import { ReactComponent as UserMenuIcon } from 'Icons/users-icon.svg';
import { ReactComponent as MappingMenuIcon } from 'Icons/mapping-icon.svg';
import { ReactComponent as RoleMenuIcon } from 'Icons/roles-icons.svg';
import { ReactComponent as OwnerShipMenuIcon } from 'Icons/ownership-icon.svg';
import { ReactComponent as ResourceMenuIcon } from 'Icons/resources-icon.svg';
import { ReactComponent as WhitelistingMenuIcon } from 'Icons/whitelisting-icon.svg';
import { ReactComponent as PoliciesMenuIcon } from 'Icons/policies-icon.svg';
import { ReactComponent as ProfileMenuIcon } from 'Icons/profile-icon.svg';
import { ReactComponent as LogoutMenuIcon } from 'Icons/logout-icon.svg';
import { ReactComponent as HamburgerMenuIcon } from 'Icons/hamburger-icon.svg';
import { ReactComponent as LogoIcon } from 'Icons/fav-logo-icon.svg';
import { ReactComponent as CollapseIcon } from 'Icons/collapse-icon.svg';
import { ReactComponent as TrainingIcon } from 'Icons/training-icon.svg';
import { ReactComponent as CoursesIcon } from 'Icons/courses-icon.svg';
import { ReactComponent as AssignmentsIcon } from 'Icons/assignments-icon.svg';
import { ReactComponent as PhishingIcon } from 'Icons/phishing-icon.svg';
import { ReactComponent as ReportsIcon } from 'Icons/reports-icon.svg';
import { ReactComponent as DashboardIcon } from 'Icons/dashboard-icon.svg';
import { ReactComponent as ModulesIcon } from 'Icons/modules-icon.svg';
import { ReactComponent as LanguageIcon } from 'Icons/language-icon.svg';
import { ReactComponent as HelpIcon } from 'Icons/help-icon.svg';
import { ReactComponent as OptionIcon } from 'Icons/option-icon.svg';
import { ReactComponent as SettingsIcon } from 'Icons/settings-icon.svg';
import { ReactComponent as RecipientProperty } from 'Icons/recipient-property-icon.svg';
import { ReactComponent as PhishingManagerWarningModal } from 'Icons/phishing-manager-warning-icon.svg';
import { ReactComponent as DarkLP } from 'LearningManager/icons/dark-LP.svg';
import { ReactComponent as DarkIndiCourses } from 'LearningManager/icons/dark-indi-courses.svg';
import { ReactComponent as Reset } from 'LearningManager/icons/reset.svg';
import { ReactComponent as RedBin } from 'LearningManager/icons/red-bin.svg';
import { ReactComponent as QuickSetupFilled } from 'LearningManager/icons/quick-setup-filled-icon.svg';
import { ReactComponent as DashIcon } from 'Icons/dash-icon.svg';



const Icons = {
	snippets: SnippetsOutlined,
	eye: Eye,
	filter: Filter,
	fileText: FileText,
	modelFund: ModelFund,
	settings: Settings,
	stack: Stack,
	search: Search,
	close: Close,
	question: QuestionCircleOutlined,
	global: GlobalOutlined,
	exclamationCircle: ExclamationCircle,
	chevronDown: ChevronDown,
	bell: Bell,
	help: Help,
	arrowLeft: ArrowLeft,
	flagUs: FlagUs,
	flagFr: FlagFr,
	flagEs: FlagEs,
	plus: Plus,
	plusEllipsis: PlusEllipsis,
	minusCircle: MinusCircle,
	more: More,
	download: Download,
	move: Move,
	check: Check,
	checkCircle: CheckCircle,
	delete: Delete,
	edit: Edit,
	password: Password,
	users: Users,
	restore: Restore,
	import: Import,
	copy: Copy,
	unlock: Unlock,
	lock: Lock,
	infoOutlined: InfoOutlined,
	hierarchy: Hierarchy,
	information: Information,
	property: Property,
	like: Like,
	dislike: Dislike,
	neutral: Neutral,
	loading: LoadingOutlined,
	trendUp: TrendUp,
	trendDown: TrendDown,
	envelope: Envelope,
	click: Click,
	newWindow: NewWindow,
	reward: Reward,
	sandglass: Sandglass,
	play: Play,
	downloadCircle: DownloadCircle,
	report: Report,
	calendar: Calendar,
	profile: Profile,
	success: Success,
	discount: Discount,
	time: Time,
	eyeCrossed: EyeCrossed,
	eyeOpened: EyeOpened,
	newEyeOpened: NewEyeOpened,
	newEyeCrossed: NewEyeCrossed,
	mappingSetting: MappingSetting,
	notStarted: NotStarted,
	inComplete: InComplete,
	inactive: InComplete,
	completed: Completed,
	needsReview: NeedsReview,
	createMapping: CreateMapping,
	unMapping: UnMapping,
	tenantSuffix: TenantSuffix,

	mappingComplete: MappingComplete,
	tenant: Tenant,
	excel: Excel,
	uploadFile: UploadFile,
	uploadPlaceholder: UploadPlaceholder,

	addNewMapping: AddNewMapping,
	createNewMapping: CreateNewMapping,
	modalConfirmation: ModalConfirmation,
	mappingEdit: MappingEdit,
	mappingTrash: MappingTrash,
	mappingIgnore: MappingIgnore,
	matches: Matches,

	alertSuccess: AlertSuccess,
	mappingSummary: MappingSummary,
	tenantFile: TenantFile,
	confirmation: Confirmation,
	removedMapping: RemovedMapping,
	newMapping: NewMapping,
	noChanges: NoChanges,
	selectSuffix: SelectSuffix,
	chevronLeft: ChevronLeft,
	chevronUp: ChevronUp,
	chevronUpDown: ChevronUpDown,
	compliant: Compliant,
	nonCompliant: NonCompliant,
	saqTooltip: SAQTooltip,
	antSelectSuffix: AntSelectSuffix,
	saqExternalLink: SAQExternalLink,
	saqSearch: SAQSearch,
	saqPercent: SAQPercent,
	saqNumber: SAQNumber,
	nonCompliantCard: NonCompliantCard,
	trendingArrow: TrendingArrow,
	unmapExclamatory: UnmapExclamatory,
	connectionArrow: ConnectionArrow,
	restoreReverse: RestoreReverse,
	remove: Remove,
	campaignAction: CampaignAction,
	noCampaign: NoCampaign,
	campaignDropdown: CampaignDropdown,
	campaignAdd: CampaignAdd,
	campaignAddDisabled: CampaignAddDisabled,
	campaignInfo: CampaignInfo,
	campaignModalClose: CampaignModalClose,
	campaignCalendar: CampaignCalendar,
	phishingManagerWarningModalClose: PhishingManagerWarningToastClose,
	phishingManagerWarningModalPrefix: PhishingManagerWarningToastPrefix,
	phishingManagerWarningModal: PhishingManagerWarningModal,
	campaignSetupDropdown: CampaignSetupDropdown,
	campaignSetupSearch: CampaignSetupSearch,
	campaignSetupClose: CampaignSetupClose,
	previousPagination: PreviousPagination,
	nextPagination: NextPagination,
	campaignPaginationNext: CampaignPaginationNext,
	campaignPaginationNextBlur: CampaignPaginationNextBlur,
	campaignStepClose: CampaignStepClose,
	venzaLanding: VenzaLanding,
	newLogo: NewLogo,
	recipientIndividual: RecipientIndividual,
	recipientBuilding: RecipientBuilding,
	recipientProperty: RecipientProperty,
	recipientRole: RecipientRole,
	recipientGroup: RecipientGroup,
	stepInProgress: StepInProgress,
	campaignError: CampaignError,
	summaryBack: SummaryBack,
	shield: Shield,
	emailSent: EmailSent,
	emailOpen: EmailOpen,
	userClick: UserClick,
	submittedData: SubmittedData,
	submittedDataFair: SubmittedDataFair,
	submittedDataPoor: SubmittedDataPoor,
	human: Human,
	systemInteraction: SystemInteraction,
	feedback: Feedback,
	usersReport: UsersReport,
	properties: Properties,
	calendarReport: CalendarReport,
	infoTooltip: InfoTooltip,
	logoIcon: LogoIcon,
	coursesIcon: CoursesIcon,
	manageIcon: ManageIcon,
	reportsIcon: ReportsIcon,
	modulesIcon: ModulesIcon,
	languageIcon: LanguageIcon,
	chatIcon: ChatIcon,
	helpIcon: HelpIcon,
	optionIcon: OptionIcon,
	settingsIcon: SettingsIcon,
	assignmentsIcon: AssignmentsIcon,
	trainingIcon: TrainingIcon,
	phishingIcon: PhishingIcon,
	collapseIcon: CollapseIcon,
	dashboardIcon: DashboardIcon,
	quickSetupIcon: QuickSetupIcon,
	customSetupIcon: CustomSetupIcon,
	reccStarsIcon: ReccStarsIcon,
	clockIcon: ClockIcon,
	pathIcon: PathIcon,
	durationIcon: DurationIcon,
	startIcon: StartIcon,
	dueDateIcon: DueDateIcon,
	assignTypeIcon: AssignTypeIcon,
	datePickerIcon: DatePickerIcon,
	createdIcon: CreatedIcon,
	orgIcon: OrgIcon,
	propIcon: PropIcon,
	roleIcon: RoleIcon,
	individualIcon: IndividualIcon,
	groupIcon: GroupIcon,
	orgOptIcon: OrgOptIcon,
	orgOptFilled: OrgOptFilled,
	propOptIcon: PropOptIcon,
	roleOptIcon: RoleOptIcon,
	individualOptIcon: IndividualOptIcon,
	groupOptIcon: GroupOptIcon,
	propOptFilled: PropOptFilled,
	roleOptFilled: RoleOptFilled,
	indiOptFilled: IndiOptFilled,
	groupOptFilled: GroupOptFilled,
	warningFilledIcon: WarningFilledIcon,
	noAssignments: NoAssignments,
	filterNoAssignments: FilterNoAssignments,
	learningPathOutline: LearningPathOutline,
	indiCourses: IndiCourses,
	indiCoursesOutline: IndiCoursesOutline,
	phishingMenuIcon: PhishingMenuIcon,
	scanningMenuIcon: ScanningMenuIcon,
	saqMenuIcon: SaqMenuIcon,
	libraryMenuIcon: LibraryMenuIcon,
	savedMenuIcon: SavedMenuIcon,
	auditLogMenuIcon: AuditLogMenuIcon,
	userMenuIcon: UserMenuIcon,
	roleMenuIcon: RoleMenuIcon,
	mappingMenuIcon: MappingMenuIcon,
	ownerShipMenuIcon: OwnerShipMenuIcon,
	resourceMenuIcon: ResourceMenuIcon,
	whitelistingMenuIcon: WhitelistingMenuIcon,
	policiesMenuIcon: PoliciesMenuIcon,
	profileMenuIcon: ProfileMenuIcon,
	logoutMenuIcon: LogoutMenuIcon,
	hamburgerMenuIcon: HamburgerMenuIcon,
	infoFilled: InfoFilled,
	grayCourseIcon: GrayCourseIcon,
	optionalCourseIcon: OptionalCourseIcon,
	tickBoxIcon: TickBoxIcon,
	warningCubeIcon: WarningCubeIcon,
	darkLP: DarkLP,
	darkIndiCourses: DarkIndiCourses,
	reset: Reset,
	redBin: RedBin,
	quickSetupFilled: QuickSetupFilled,
	dashIcon: DashIcon,
	gear:gear,
	multiusers:multiusers,
	table,
};

export default Icons;
